export const initHamburgerMenu = () => {
  const hamburgerWrap = document.querySelector('.header-logo .hamburgerwrap');
  const header = document.querySelector('#header');

  if (!hamburgerWrap || !header) return;

  // ハンバーガーメニューの開閉処理
  hamburgerWrap.addEventListener('click', () => {
    header.classList.toggle('is-active');
    document.body.style.overflow = document.body.style.overflow === 'hidden' ? 'auto' : 'hidden';
  });

  // 画面幅が990px以上になったらハンバーガーメニューをリセット
  const resetMenuOnResize = () => {
    if (window.innerWidth >= 990) {
      header.classList.remove('is-active');
      document.body.style.overflow = 'auto';
    }
  };
  window.addEventListener('resize', resetMenuOnResize);

  // SP用アコーディオンメニュー（990px未満時）
  const initAccordionInHamburger = () => {
    const closeDropdown = (el) => {
      el.style.height = el.scrollHeight + 'px';
      requestAnimationFrame(() => {
        el.style.height = '0';
      });
      el.addEventListener('transitionend', () => {
        el.classList.remove('is-open');
        el.style.height = '';
      }, { once: true });
    };

    const openDropdown = (el) => {
      el.classList.add('is-open');
      el.style.height = '0';
      requestAnimationFrame(() => {
        el.style.height = el.scrollHeight + 'px';
      });
      el.addEventListener('transitionend', () => {
        el.style.height = '';
      }, { once: true });
    };

    const triggers = document.querySelectorAll('.js-menu-sp');

    triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        if (window.innerWidth >= 990) return;

        e.preventDefault();

        const content = trigger.nextElementSibling;

        if (!content || !content.classList.contains('dropdown')) return;

        const isOpen = content.classList.contains('is-open');

        // 他のアコーディオンを閉じる
        document.querySelectorAll('.dropdown.is-open').forEach(openContent => {
          if (openContent !== content) {
            closeDropdown(openContent);

            const otherTrigger = openContent.previousElementSibling;
            if (otherTrigger && otherTrigger.classList.contains('js-menu-sp')) {
              otherTrigger.classList.remove('-active');
            }
          }
        });

        // 表示トグル
        if (isOpen) {
          trigger.classList.remove('-active');
          closeDropdown(content);
        } else {
          trigger.classList.add('-active');
          openDropdown(content);
        }
      });
    });
  };

  // PC用ドロップダウンメニュー（990px以上時）
  const initPCDropdownMenu = () => {
    const parentItems = document.querySelectorAll('.nav .item.-parent');

    parentItems.forEach(item => {
      const label = item.querySelector('.label');
      const dropdown = item.querySelector('.dropdown');

      if (!label || !dropdown) return;

      label.addEventListener('click', (e) => {
        if (window.innerWidth < 990) return;

        e.preventDefault();

        document.querySelectorAll('.nav .item.-parent .dropdown.is-open').forEach(openDropdown => {
          if (openDropdown !== dropdown) {
            openDropdown.classList.remove('is-open');
          }
        });

        dropdown.classList.toggle('is-open');
      });

      document.addEventListener('click', (e) => {
        if (window.innerWidth >= 990 && !item.contains(e.target)) {
          dropdown.classList.remove('is-open');
        }
      });

      item.addEventListener('mouseleave', () => {
        if (window.innerWidth >= 990) {
          dropdown.classList.remove('is-open');
        }
      });
    });
  };

  // SP用: アンカーリンククリック時にメニューを閉じる
  const initCloseOnAnchorClick = () => {
    const navLinks = document.querySelectorAll('.nav a[href*="#"]');

    navLinks.forEach(link => {
      link.addEventListener('click', () => {
        if (window.innerWidth < 990) {
          header.classList.remove('is-active');
          document.body.style.overflow = 'auto';
        }
      });
    });
  };

  initAccordionInHamburger();
  initPCDropdownMenu();
  initCloseOnAnchorClick();
};
